// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetTenantRequestModel from '../../model/get-tenant-request-model';
import GetTenantRequestDTO from '../dto/get-tenant-request-dto';
import dtoSchema from '../schemas/get-tenant-request-schema';

export default abstract class GetTenantRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetTenantRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetTenantRequestDTO>): GetTenantRequestModel;
  static toModel(dto: DeepPartial<GetTenantRequestDTO> | undefined | null): GetTenantRequestModel | undefined;
  static toModel(dto: DeepPartial<GetTenantRequestDTO> | undefined | null): GetTenantRequestModel | undefined {
    return dto ? new GetTenantRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetTenantRequestModel> | GetTenantRequestModel): GetTenantRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetTenantRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetTenantRequestModel, can not map to GetTenantRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
